import type { MessengerBridge } from '../bridge'

type LinkRequiredScreenProps = {
  bridge: MessengerBridge
  message: string
  rfqId: number | null
}

const platformLabel = (platform: MessengerBridge['platform']): string => {
  switch (platform) {
    case 'telegram':
      return 'Telegram'
    case 'max':
      return 'MAX'
    default:
      return 'Провизиум'
  }
}

export const LinkRequiredScreen = ({ bridge, message, rfqId }: LinkRequiredScreenProps) => (
  <main className="app-layout app-layout--standalone">
    <header className="app-layout__header">
      <p className="eyebrow">Провизиум · {platformLabel(bridge.platform)}</p>
      <h1 className="app-layout__title">Подключите аккаунт</h1>
      <p className="app-layout__subtitle">
        Мои прайсы, поиск, корзина-бланк и аналитика — после привязки организации
      </p>
    </header>

    <div className="app-layout__content echat-orders">
      <article className="echat-panel">
        <span className="echat-badge echat-badge--muted">Требуется настройка</span>
        <p className="echat-panel__text">{message}</p>
        {rfqId !== null ? (
          <p className="echat-panel__meta">Заявка №{rfqId}</p>
        ) : null}
        <ol className="echat-lines">
          <li>Войдите в личный кабинет на market.provisium.ru</li>
          <li>Настройки → Уведомления → Market bot → Подключить</li>
          <li>Вернитесь в это приложение — вход выполнится автоматически</li>
        </ol>
      </article>

      <p className="echat-muted">
        Вы уже в боте Провизиума — отдельно открывать его не нужно. Достаточно привязать аккаунт в
        кабинете.
      </p>

      <button type="button" className="echat-btn echat-btn--ghost" onClick={() => bridge.close()}>
        Закрыть приложение
      </button>
    </div>
  </main>
)
